import React from 'react';
import PropTypes from 'prop-types';
import Container from 'reactstrap/lib/Container';
import { LINKS } from 'site-modules/shared/components/footer/footer-data';
import { AnimatedCollapse } from 'site-modules/shared/utils/collapse-utils';
import { StickyTray } from 'site-modules/shared/components/sticky-tray/sticky-tray';

export function EndlessScrollFooter({ isActive }) {
  return (
    <StickyTray portalId="sticky-tray-portal-bottom" showTimeout={150} isSticky>
      <div className="endless-scroll-footer overflow-y-hidden">
        <AnimatedCollapse className="bg-light" isOpen={isActive}>
          <Container className="py-1">
            <ul className="mb-0_25 d-flex flex-wrap list-unstyled">
              {LINKS.filter(({ homepageOnly }) => !homepageOnly).map(({ href, text }) => (
                <li className="heading-7 fw-normal p-0 me-1 me-md-1_5 mb-0_25" key={text}>
                  <a href={href} rel="nofollow">
                    {text}
                  </a>
                </li>
              ))}
            </ul>
            <div className="copyright heading-7 fw-normal text-gray-darker">
              <a href="/">&copy; Edmunds.com, Inc.</a>, a wholly owned subsidiary of CarMax, Inc. By using edmunds.com,
              you consent to the monitoring and storing of your interactions with the website, including by an Edmunds
              vendor, for use in improving and personalizing our services. See our{' '}
              <a href="/about/privacy.html">Privacy Statement</a> for details.
            </div>
          </Container>
        </AnimatedCollapse>
      </div>
    </StickyTray>
  );
}

EndlessScrollFooter.propTypes = {
  isActive: PropTypes.bool,
};

EndlessScrollFooter.defaultProps = {
  isActive: false,
};
